<script lang="ts">
	import { t } from 'svelte-i18n';
	import Tag from '$lib/elements/tags/Tag.svelte';
	import type { DecisionToolMarks } from '$lib/types/props';
	import { getBgColorClassName } from '$lib/theme/colors';

	type DecisionToolMark = {
		letter: DecisionToolMarks;
		label: string;
		color: string;
	};

	let grades: DecisionToolMark[] = [
		{
			letter: 'A',
			label: $t('decisionTool.marksLabel.A'),
			color: 'decision-tool-A'
		},
		{
			letter: 'B',
			label: $t('decisionTool.marksLabel.B'),
			color: 'decision-tool-B'
		},
		{
			letter: 'C',
			label: $t('decisionTool.marksLabel.C'),
			color: 'decision-tool-C'
		},
		{
			letter: 'D',
			label: $t('decisionTool.marksLabel.D'),
			color: 'decision-tool-D'
		},
		{
			letter: 'E',
			label: $t('decisionTool.marksLabel.E'),
			color: 'decision-tool-E'
		}
	];
</script>

<div class="flex justify-between items-center space-x-2">
	{#each grades as grade}
		<Tag
			props={{
				label: `${grade.letter} : ${grade.label}`,
				classNames: `
          ${getBgColorClassName(grade.color)}
          text-white
          py-4
          flex-1
          flex
          justify-center
          items-center
          rounded-md
          font-bold
          text-lg
        `
			}}
		/>
	{/each}
</div>
